import React, { useEffect, useState, useRef } from 'react';
import axios from '../axiosConfig';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { filterBy } from "@progress/kendo-data-query";
import { orderBy } from "@progress/kendo-data-query";
import '@progress/kendo-theme-default/dist/all.scss';
import './GeneralGrid';
import CustomLockedCell from './customizedColumns/CustomLockedCell'
import SidePanel from './SidePanel';
import useProfileData from '../services/ProfileDataService';
import CustomDropdownCell from './customizedColumns/CustomDropdownCell';
import AssignButton from './customizedColumns/AssignButton';
import CustomFilter from '../components/customizedFilters/CustomFilter';
import Loader from './Loader';
import Toast from './ToastNotification';
import Modal from './Modal';
import { getCurrentLine,subscribeToCurrentLineChanges  } from '../services/CurrentLineService';
import useDebounce from "./../Utilities/useDebounce";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { GET_CANSHIPP_ORDERS_LIST } from '../Helpers/queries/GetOrdersList';
import { useQueryClient } from '@tanstack/react-query';
import { useCanShippOrdersData } from '../Helpers/Hooks/UseGetOrdersData';
import { ROOFTOP_LINE } from '../Utilities/constants';
import { defaultColumnsNewOrders, getVisibleColumns } from '../Utilities/defaultColumnsDefinition';
import { useGetOrderDetailData } from '../Helpers/Hooks/UseGetOrderDetail';

const CancelledShippedGrid = ({ columns = [], dateRange,
  filter, setFilter,
  prevFilter, setPrevFilter,
  currentFilter, setCurrentFilter, onRemoveAll,
  setRemoveFilter, dropdownFilters, setDropdownFilters, removeFilter, disabled,
  exportExcel, setExportExcel
}) => {
  const [scheduleData, setScheduleData] = useState({ TotalRows: 0, Items: [] });
  const [users, setUsers] = useState([]);  
  const queryClient = useQueryClient();
  
  const storedCurrentPage = localStorage.getItem('currentPageCanShippView');
  const storedPage = localStorage.getItem('pageCanShippView');
  const storedStartDate = localStorage.getItem('startDate');
  const storedEndDate = localStorage.getItem('endDate');

  const [pageSize, setPageSize] = useState(storedPage ? JSON.parse(storedPage).take: 50);
  const [sort, setSort] = useState([{ field: "isPriority", dir: "desc" }]);


  const [page, setPage] = useState(
    { skip: storedPage ? JSON.parse(storedPage).skip : 0,
     take: storedPage ? JSON.parse(storedPage).take : pageSize 
    });

  const { token, profileImageData } = useProfileData();
  const [currentPage, setCurrentPage] = useState(storedCurrentPage ? JSON.parse(storedCurrentPage) : 1);
  const [totalRows, setTotalRows] = useState(0);
  const [department, setDepartment] = useState(getCurrentLine().ProdFamilyId);

  const [toast, setToast] = useState(null);
  const [idtoast, setIdtoast] = useState(1);
  const viewAlias = 1;
  const [productName, setProductName] = useState(getCurrentLine().ProdFamilyName); 
  const debouncedFilter = useDebounce(filter, "600");
  
  const _export = React.useRef(null);
  const _formattedDate = (() => {
    const today = new Date();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    const year = today.getFullYear();
    return `${month}-${day}-${year}`;
  })();

  const excelExport = () => {
    if (_export.current !== null && exportExcel === true) {
      const today = new Date();
      _export.current.save(users);
    }
  };

  // Columns export
  const exportColumns = columns
  .filter(col => col.visible === true)
  .map((col, index) => (
    <ExcelExportColumn key={index} field={col.field} title={col.title} />
  ));

  useEffect(() => {
    excelExport();
    setExportExcel(false);
  }, [exportExcel === true]);

  const dateColumn = 'DraftingDueDate';     

  //Move to MF
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  const { data: orderDetailIdData } = useGetOrderDetailData({
    token,
    orderDetailId: selectedOrderId,
    view: viewAlias,
    setToast,
  });

  useEffect(() => {
    if (orderDetailIdData) {
      const updatedItem = {
        ...orderDetailIdData,
        orderNumber: 0,
        orderNumberChecker: 0,
      };
      
      setEditItem(updatedItem);			
    }
  }, [orderDetailIdData]);

  //Notice changes on current Line service
  useEffect(() => {
    const unsubscribe = subscribeToCurrentLineChanges(newCurrentLine => {
      setDepartment(newCurrentLine.ProdFamilyId);
      setProductName(newCurrentLine.ProdFamilyName);
    });
    return () => {
      unsubscribe();
    };
  }, []);  

  useEffect(() => {
    setToast({ showToast: false });
    setIdtoast(idtoast + 1);

    queryClient.invalidateQueries([GET_CANSHIPP_ORDERS_LIST]);      
  }, [token, page.skip, page.take, sort, dateRange, debouncedFilter, department]);

  useEffect(() => {
    setPage({ skip: 0, take: pageSize });
    setCurrentPage(1);
  }, [dateRange, sort, debouncedFilter]);

  const [filtro, setFiltro] = useState(null)

  useEffect(() => {
    localStorage.setItem('filtersGeneralView', JSON.stringify(filter, null, 2));
    const sotredFilters = JSON.stringify(filter?.filters, null, 2);

    if(sotredFilters)
    localStorage.setItem('dropDownFiltersGeneralView', sotredFilters);    
  }, [filter]);


  const filterConfig = {
    text: "text",
    number: "numeric",
    boolean: "boolean",
    date: "date",
    dropdown: {
      filterCell: (props) => {
        const { field } = props;
        return (
          <CustomFilter
            {...props}
            data={users}
            field={field}
            currentFilterField={field}
            onSelectionChange={handleCustomFilterChange}
            onRemoveAll={onRemoveAll}
            selectedOptions2={currentFilter}
            selectedFilter={filtro}
            removeFilter={removeFilter}
            prevFilter={prevFilter}
            filter={dropdownFilters}
            viewOption={viewAlias}            
          />
        );
      }
    }
  };

  const handleAssignError = async () => {

    setIdtoast(idtoast + 1);
    setToast({ showToast: false });
    setToast({ showToast: true, message: 'An error occurred while assigning the order', type: 'error' });
  };
  
  const handleCustomFilterChange = (selectedOptions, currentFilterField) => {
    
    setFilter((prevFilter) => {
      if (!prevFilter) {
        // if there are not a existing filter creatte a new one
        return {
          logic: "or",
          filters: [
            ...selectedOptions.map((option) => ({
              field: currentFilterField,
              operator: "eq",
              value: option,
            })),
          ],
        };
      } else {
        // if there already exist a filter add current selection
        const updatedFilters = [
          ...prevFilter.filters.filter((filter) => filter.field !== currentFilterField),
          ...selectedOptions.map((option) => ({
            field: currentFilterField,
            operator: "eq",
            value: option,
          })),
        ];

        return {
          ...prevFilter,
          filters: updatedFilters,
        };
      }
    });
    setFiltro(currentFilterField);
    setCurrentFilter(selectedOptions);
    localStorage.setItem('currentFilterGeneralView', JSON.stringify(selectedOptions));
    setRemoveFilter(false);
    const allFields = filter?.filters?.map(filter => filter.field) || [];
    allFields.unshift(currentFilterField);
    const allFields2 = [...new Set(allFields)];
    setPrevFilter(allFields2);
    localStorage.setItem('currentPrevFilterGeneralView', JSON.stringify(allFields2));
    setDropdownFilters(filter?.filters);
  };


  const pageChange = (event) => {
    const targetEvent = event.targetEvent;
    const newPage = {
      skip: event.page.skip,
      take: targetEvent.value === 'All' ? totalRows : event.page.take,
    };

    setPage(newPage);
    setCurrentPage(newPage.skip / pageSize + 1);

    localStorage.setItem('pageCanShippView', JSON.stringify(newPage));
    localStorage.setItem('currentPageCanShippView', JSON.stringify(newPage.skip / pageSize + 1));
  };

  const handleFilterChange = (event) => {
    setFilter(event.filter);
  };

  const filteredUsers = filterBy(users, filter);
  const sortedUsers = orderBy(filteredUsers, sort);

  const [selectedColumns, setSelectedColumns] = useState(columns);

    //move to mf
    const selectedVisibleColumns = selectedColumns
    .filter(column => column.visible)
    .map(column => column.field);

  const visibleColumns = getVisibleColumns(selectedVisibleColumns, defaultColumnsNewOrders);

  const { data: ordersData, isLoading} = useCanShippOrdersData({
    department,
    dateColumn,
    sort,
    page,
    dateRange,
    storedStartDate,
    storedEndDate,
    filter,
    viewAlias,    
    productName,
    token,
    debouncedFilter,
    visibleColumns,
    setToast,
  });  

  useEffect(() => {
    
    if (ordersData) {               
      setScheduleData({
        TotalRows: ordersData.totalRows,
        Items: ordersData.items,
      });
      
      setTotalRows(ordersData.totalRows);
      setUsers(ordersData.items);
    }
  }, [ordersData]);  

  useEffect(() => {
    setSelectedColumns(columns);
  }, [columns], [sortedUsers]);

  const [selectedColumnFields, setSelectedColumnFields] = useState(columns.map(column => column.field));

  useEffect(() => {
    setSelectedColumnFields(columns.map(column => column.field));
  }, [columns]);

  const [openForm, setOpenForm] = React.useState(false);
  const [editItem, setEditItem] = React.useState();
  const [data, setData] = React.useState(sortedUsers);

  const enterEdit = async (item) => {
    
    // const updatedItem = {
    //   ...item,
    //   orderNumber: 0,
    //   orderNumberChecker: 0,
    // };

    // setOpenForm(true);
    // setEditItem(updatedItem);

    setOpenForm(true);
		setSelectedOrderId(item.orderDetailId);	

};

  const handleDesignerDetailHrsChange = (newDesignerDetailHrs,) => {
    setEditItem((prevItem) => ({
      ...prevItem,
      orderNumber: newDesignerDetailHrs      
    }));
  };

  const handleDesignerCheckerHrsChange = (newDesignerCheckerHrs) => {
    setEditItem((prevItem) => ({
      ...prevItem,
      orderNumberChecker: newDesignerCheckerHrs
    }));
  };

  useEffect(() => {
    setPageSize(page.take);
  }, [page]);


  const handleSubmit = (event) => {
    let newData = data.map((item) => {
      if (event.item === item.item) {
        item = {
          ...event,
        };
      }
      return item;
    });
    setData(newData);



    setOpenForm(false);
  };

  const [profileImgAssigned, setProfileImgAssigned] = useState();
  const [designerName, setName] = useState();
  const [modalVisible, setModalVisible] = useState(false);

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const MyCustomLockedCell = (props) => (
    <CustomLockedCell {...props} enterEdit={enterEdit} />
  );

  const handleSortChange = (e) => {
    setSort(e.sort || []);
  };

  // Zoom adjustment
  const [zoomLevel, setZoomLevel] = useState(1);
  // TODO: To use Css calc() for handle the hight instead
  const [gridHeight, setGridHeight] = useState(window.innerHeight - 270);

  useEffect(() => {
    const handleResize = () => {
      const viewportWidth = window.innerWidth;
      const windowWidth = window.outerWidth;
      const newZoomLevel = windowWidth / viewportWidth;
      setZoomLevel(newZoomLevel);

      const newGridHeight = window.innerHeight - 270;
      setGridHeight(newGridHeight);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Zoom adjustment

  return (
    <div style={{ position: 'relative' }}>  
      {isLoading && (
        <Loader></Loader>
      )}

      <Modal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        title='Oops! It looks like this task was already taken'
        message={designerName + ' took this task'}
        type='TAKENORDER'
        image= {profileImgAssigned}
      />

      {toast && <Toast key={idtoast} showToast={toast.showToast} message={toast.message} type={toast.type} />}

      <div style={{ height: 'calc(100vh - 290px)', marginBottom: '15px', position: 'relative' }}>
        <ExcelExport
                  data={users || []}
                  ref={_export}
                  fileName={`cancelled_shipped_${_formattedDate}.xlsx`}
                >
                  {exportColumns}
                </ExcelExport>
        <Grid
          className='roboto-15-400'
          data={(users || [])}
          skip={page.skip}
          take={page.take}
          total={totalRows}
          pageable={{
            buttonCount: 4,
            type: "input",
            pageSizes: [50, 150, 200, totalRows].filter(num => num <= totalRows),
            pageSize: pageSize,
          }}
          onPageChange={pageChange}
          sortable={true}
          filterable={true}
          filter={filter}
          onFilterChange={handleFilterChange}
          resizable
          reorderable
          sort={sort}
          onSortChange={handleSortChange}
          style={{
            borderRadius: '8px',
            display: 'flex',
            margin: '15px',
            height: 'inherit'
          }}
        >
          <GridColumn
            className='roboto-15-400'
            reorderable={false}
            sortable={false}
            filterable={false}
            editable={false}
            field="rowIndex"
            title="#"
            width="40px"
          />
          {selectedColumns
            .filter(
              (column) => 
            column.visible &&
            !(column.field === 'etoproc' && getCurrentLine().ProdFamilyName !== ROOFTOP_LINE)
            )
            .map((column) => {
              if (column.field === 'esoistatusDesc') {
                return (
                  <GridColumn
                    className='roboto-15-400'
                    key={column.field}
                    field={column.field}
                    title={column.title}
                    width={column.minWidth}
                    filter={filterConfig[column.filterType]}
                    filterCell={filterConfig[column.filterType].filterCell}
                    cell={(props) => (
                      <CustomDropdownCell
                        {...props}
                        updateData={(updatedData) => handleSubmit({ userId: props.dataItem.userId, ...updatedData })}
                        disabled={true}
                        employeeRole={0}
                      />
                    )}
                  />
                );
              } else if (column.field === 'designerChecker' || column.field === 'designerDetail') {
                return (
                  <GridColumn
                    className='roboto-15-400'
                    key={column.field}
                    field={column.field}
                    title={column.title}
                    width={column.minWidth}
                    filter={filterConfig[column.filterType]}
                    filterCell={filterConfig[column.filterType].filterCell}
                    cell={(props) => {
                      if ((props.dataItem.itemType === 'FIN' && column.field === 'designerDetail') || (props.dataItem.itemType !== 'FIN')) { 
                        return (
                          <AssignButton
                            {...props}
                            updateData={(updatedData) => handleSubmit({ userId: props.dataItem.userId, ...updatedData })}
                            token={token}
                            onErrorAssign={handleAssignError}                            
                            disabled={true}
                            employeeRole={0}
                          />
                        );
                      } else { //do not show button if it is standard and checker
                        return <div style={{ width: '100%', height: '100%' }}></div>;
                      }
                    }}
                  />
                );

              }              
              else {
                if (column.field === 'etoproc') 
                return(<GridColumn
                  className='roboto-15-400'
                  sortable={true}
                  key={column.field}
                  field={column.field}
                  title={column.title}
                  headerCell={column.header}
                  width={column.minWidth}
                  filter={filterConfig[column.filterType]}
                  format="{0:d}"
                  filterCell={filterConfig[column.filterType].filterCell}
                  cell={(props) => {
                    if ((props.dataItem.itemType !== 'FIN' && column.field === 'etoproc') ) { 
                      return (
                        column.cell(props)
                      );
                    } else { 
                      return <div style={{ width: '100%', height: '100%' }}></div>;
                    }
                  }}
                />)
                else if (column.field === 'sellingPrice') {
                return (
                  <GridColumn
                  className='roboto-15-400'
                  sortable={true}
                  key={column.field}
                  field={column.field}
                  title={column.title}
                  headerCell={column.header}
                  width={column.minWidth}
                  filter="numeric"  
                  format="{0:n2}"
                  filterCell={filterConfig[column.filterType].filterCell}
                  cell={column.cell}
                />
                );
              }          
              else if (column.field === 'phase') {
                return (
                  <GridColumn
                    className='roboto-15-400'
                    sortable={false}
                    key={column.field}
                    field={column.field}
                    title={column.title}
                    headerCell={column.header}
                    width={column.minWidth}
                    filter={filterConfig[column.filterType]}
                    filterable={false}
                    filterCell={filterConfig[column.filterType].filterCell}
                    cell={column.cell}
                  />
                  );
              }            
              else
              return (
                <GridColumn
                  className='roboto-15-400'
                  sortable={true}
                  key={column.field}
                  field={column.field}
                  title={column.title}
                  headerCell={column.header}
                  width={column.minWidth}
                  filter={filterConfig[column.filterType]}
                  format="{0:d}"
                  filterCell={filterConfig[column.filterType].filterCell}
                  cell={column.cell}
                />
              );
              }
            })}

          <GridColumn
            filterable={false}
            editable={false}
            width="40px"
            locked={true}
            cell={MyCustomLockedCell}
          />
        </Grid>
      </div>

      {openForm && editItem && editItem.orderDetailId && (
        <SidePanel
          cancelEdit={handleCancelEdit}          
          item={editItem}
          onDesignerCheckerHrsChange={handleDesignerCheckerHrsChange}
          onDesignerDetailHrsChange={handleDesignerDetailHrsChange}
          disabled= {true}
        />
      )}
    </div>
  );
}

export default CancelledShippedGrid;